/**
 * 🪝 Asset Hooks
 *
 * Asset CodeGen에 의해 자동 생성된 React Hooks
 */

import { useMemo } from 'react';
import { AssetName, AssetInfo } from './types';
import { getAssetPath, getAssetInfo } from './utils';

/**
 * Asset 경로를 가져오는 Hook
 */
export function useAssetPath(name: AssetName): string {
	return useMemo(() => getAssetPath(name), [name]);
}

/**
 * Asset 정보를 가져오는 Hook
 */
export function useAssetInfo(name: AssetName): AssetInfo | null {
	return useMemo(() => getAssetInfo(name), [name]);
}
